import React, { useState, useEffect } from 'react';
import { AreaHeader, GoBack } from 'js/components/Configurations/CreateClub/styles';

import * as S from '../../../components/Establishment/styles';
import * as D from 'js/components/DesignSystem/styles';

import thumbnailPromocao from 'styles/assets/promocao/thumbnail-promocao.png';
import listaFotos from 'styles/assets/promocao/listaFotos-promocao.png';
import cuponsValidos from 'styles/assets/promocao/cuponsValidos.png';
import nomeCupom from 'styles/assets/promocao/nomeCupom.png';
import ImportImage from 'js/components/TriiboComponents/ImportImage';

import placeholder from 'styles/assets/placeholder/placeholder_triibo.png';
import placeholderThumbnail from 'styles/assets/placeholder/placeholder_thumbnail.png';
import { useHistory } from 'react-router-dom';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  TextField,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Switch,
  MenuItem,
  Select,
  Grid,
  Radio,
  RadioGroup,
  Tooltip,
  Chip,
  Paper,
  Box,
  Autocomplete,
} from '@mui/material';
import { ArrowBack, Save, Close, Help, FileCopy } from '@mui/icons-material';
import { ArrowLeft } from 'phosphor-react';

import { BsXLg } from 'react-icons/bs';

import Downshift from 'downshift';

import Loading from 'js/containers/Loading/Loading';
import { updateStorePromotionInformationAction } from 'js/core/actions/storePromotionInformationActions';
import { downloadImage, downloadImageAsBlob } from 'js/library/services/StorageManager';

import {
  convertToDate,
  msToTime,
  convertIsoToDate,
  isBase64,
  blobToBase64,
} from 'js/library/utils/helpers.js';
import EditShowId from 'js/components/Store/Promotion/EditShowId';
import { getVoucherTemplate } from 'js/library/utils/API/getVoucherTemplate';
import { getStoreByEstablishment } from 'js/library/utils/API/Store/apiGetStoreByEstablishment';
import readEstablishment from 'js/library/utils/API/Establishment/apiReadEstablishment';

import Transition from 'js/containers/Transition';
import StyledBadge from 'js/containers/Store/StyledBadge';
import StyledBadge2 from 'js/containers/Store/StyledBadge2';
import renderInput from 'js/containers/Store/InputKeywords';

import deburr from 'lodash/deburr';
import { renderSuggestion } from 'js/containers/Store/suggestion';
import { getKeywords } from 'js/library/utils/API/SearchUser/apiGetKeywords';
import { toast } from 'react-toastify';
import { getStoreChangeRequest } from 'js/library/utils/API/Store/apiGetStoreChangeRequest';

let suggestions = [];

function getSuggestions(value) {
  const inputValue = deburr(value.trim()).toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  return inputLength === 0
    ? []
    : suggestions.filter((suggestion) => {
        const keep =
          count < 5 && suggestion.label.slice(0, inputLength).toLowerCase() === inputValue;

        if (keep) {
          count += 1;
        }

        return keep;
      });
}

export default function StorePromotionInformation(props) {
  const history = useHistory();

  const editPage = window.location.href.includes('/edit');

  //convertendo enable date
  let enableDateInit = new Date(props?.location?.state?.enableDate || Date.now());

  const enableYear = enableDateInit.getFullYear();
  const enableMonth = String(enableDateInit.getMonth() + 1).padStart(2, '0');
  const enableDay = String(enableDateInit.getDate()).padStart(2, '0');
  const enableHour = String(enableDateInit.getHours()).padStart(2, '0');
  const enableMinute = String(enableDateInit.getMinutes()).padStart(2, '0');

  enableDateInit = `${enableYear}-${enableMonth}-${enableDay}T${enableHour}:${enableMinute}`;

  //convertendo disable date
  let disableDateInit = new Date(
    props?.location?.state?.disableDate || Date.now() + 86400000 * 365
  );

  const disableYear = disableDateInit.getFullYear();
  const disableMonth = String(disableDateInit.getMonth() + 1).padStart(2, '0');
  const disableDay = String(disableDateInit.getDate()).padStart(2, '0');
  const disableHour = String(disableDateInit.getHours()).padStart(2, '0');
  const disableMinute = String(disableDateInit.getMinutes()).padStart(2, '0');

  disableDateInit = `${disableYear}-${disableMonth}-${disableDay}T${disableHour}:${disableMinute}`;

  //convertendo disable coupon date
  let disableDateCouponAux = new Date(Date.now() + 86400000 * 365);

  disableDateCouponAux = convertIsoToDate(disableDateCouponAux);

  //dados do estabelecimento
  const idEstabelecimento = props.match.params.id;
  const [idGestor, setIdGestor] = useState(null);
  const [nomeEstabelecimento, setNomeEstabelecimento] = useState('');
  const [lat, setLat] = useState(0);
  const [long, setLong] = useState(0);
  const [address, setAddress] = useState('');
  const [neighborhood, setNeighborhood] = useState('');

  //dados do template
  const [id, setId] = useState(null);
  const [consumoUnico, setConsumoUnico] = useState(false);
  const [cooldownDays, setCooldownDays] = useState(0);
  const [cooldownHours, setCooldownHours] = useState(0);
  const [cooldownMinutes, setCooldownMinutes] = useState(0);
  const [dataGeracao, setDataGeracao] = useState(Date.now());
  const [descricao, setDescricao] = useState('');
  const [detailsDescription, setDetailsDescription] = useState('');
  const [credit, setCredit] = useState(0);
  const [detailsTitle, setDetailsTitle] = useState('');
  const [generator, setGenerator] = useState(false);
  const [nomeTemplate, setNomeTemplate] = useState('');
  const [plural, setPlural] = useState('');
  const [qtdDisponivel, setQtdDisponivel] = useState(0);
  const [hasSimultaneo, setHasSimultaneo] = useState(false);
  const [qtdSimultaneo, setQtdSimultaneo] = useState(1);
  const [region, setRegion] = useState('local');
  const [singular, setSingular] = useState('');
  const [titulo, setTitulo] = useState('');
  const [campanhaTriibo, setCampanhaTriibo] = useState(false);
  const [sendSMS, setSendSMS] = useState(false);
  const [showVoucherCodes, setShowVoucherCodes] = useState(false);
  const [consumerHelpText, setConsumerHelpText] = useState('');
  const [showQrCodeVoucher, setShowQrCodeVoucher] = useState(false);
  const [expirationType, setExpirationType] = useState('fixed');
  const [disableDateCoupon, setDisableDateCoupon] = useState(disableDateCouponAux);
  const [onSendExpiration, setOnSendExpiration] = useState(1);
  const [type, setType] = useState('store');
  const [consumo, setConsumo] = useState('posterior');
  const [foto, setFoto] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [fileFoto, setFileFoto] = useState(null);
  const [fileThumbnail, setFileThumbnail] = useState('');
  const [couponGetMode, setCouponGetMode] = useState('simpleGetMode');
  const [templateInfo, setTemplateInfo] = useState({});

  //dados da Store
  const idStore = props.match.params.idOferta;
  const [level, setLevel] = useState(99);
  const [description, setDescription] = useState('');
  const [showQRCodeStore, setShowQRCodeStore] = useState(false);
  const [title, setTitle] = useState('');
  const [storeType, setStoreType] = useState('promotion');
  //state usado para detectar mudança do tipo e alterar a pasta da imagem
  const [storeTypeInitial, setStoreTypeInitial] = useState('promotion');
  const [voucherPaymentTemplates, setVoucherPaymentTemplates] = useState([]);
  const [typeRescue, setTypeRescue] = useState('voucher');
  const [dataStoreByEstablishment, setDataStoreByEstablishment] = useState([]);
  const [optionsOpen, setOptionsOpen] = useState(false);
  const [autocompleteValue, setAutocompleteValue] = useState(null);
  const [autoValidate, setAutoValidate] = useState('cliente');
  const [deliverType, setDeliverType] = useState(1);
  const [cost, setCost] = useState(0);
  const [isPublished, setIsPublished] = useState(true);
  const [enableDate, setEnableDate] = useState(enableDateInit);
  const [disableDate, setDisableDate] = useState(disableDateInit);
  const [buttonLabel, setButtonLabel] = useState('');
  const [buttonDescription, setButtonDescription] = useState('');
  const [showButtonDescription, setShowButtonDescription] = useState(false);
  const [goToPlaceLabel, setGoToPlaceLabel] = useState('');
  const [showGoToPlace, setShowGoToPlace] = useState(false);
  const [consumed, setConsumed] = useState(false);
  const [keywordsSetConsumption, setKeywordsSetConsumption] = useState('');
  const [keywords, setKeywords] = useState('');
  const [keywordsSetConsumptionList, setKeywordsSetConsumptionList] = useState([]);
  const [keyWordsSet, setKeywordsSet] = useState([]);
  const [messageBlockedKw, setMessageBlockedKw] = useState('');
  const [tags, setTags] = useState([]);
  const [tagCapture, setTagCapture] = useState('');

  const [priceInReais, setPriceInReais] = useState(
    Math.round(0 / 10)
      .toFixed(2)
      .replace('.', ',')
  );
  const [storeThumbnail, setStoreThumbnail] = useState(null);
  const [fileStoreThumbnail, setFileStoreThumbnail] = useState(null);
  const [storePhoto, setStorePhoto] = useState(null);
  const [fileStorePhoto, setFileStorePhoto] = useState('');
  const [photoListFile, setPhotoListFile] = useState([]);

  const [goBack, setGoBack] = useState(false);
  const [unlimitedDisableDate, setUnlimitedDisableDate] = useState(
    Math.abs(Date.parse(disableDate) - Date.parse(enableDate)) > 1000 * 60 * 60 * 24 * 365 * 5
  );

  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogGoBack, setOpenDialogGoBack] = useState(false);
  const [sameImages, setSameImages] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (
      (isBase64(fileThumbnail) && fileThumbnail !== null) |
      (isBase64(fileFoto) && fileFoto !== null) |
      (isBase64(fileStoreThumbnail) && fileStoreThumbnail !== null) |
      (isBase64(fileStorePhoto) && fileStorePhoto !== null) |
      (photoListFile.length > 0 && photoListFile.some((item) => isBase64(item) && item !== null))
    ) {
      setGoBack(true);
    }
  }, [fileThumbnail, fileFoto, fileStoreThumbnail, fileStorePhoto, photoListFile]);

  useEffect(() => {
    const fetchEstablishmentData = async () => {
      try {
        const result = await readEstablishment(idEstabelecimento);
        const dataEstablishment = result;

        setIdGestor(dataEstablishment.idGestor);
        setNomeEstabelecimento(dataEstablishment.nome);
        setLat(dataEstablishment.lat);
        setLong(dataEstablishment.long);
        setAddress(
          dataEstablishment.endereco === 'Brasil'
            ? dataEstablishment.endereco
            : `${dataEstablishment.logradouro}, ${dataEstablishment.numero} - ${dataEstablishment.bairro}, ${dataEstablishment.cidade} - ${dataEstablishment.estado}, `
        );
        setNeighborhood(dataEstablishment.bairro);
      } catch (error) {
        console.error('Erro ao obter dados do estabelecimento', error);
      }
    };

    fetchEstablishmentData();

    //baixando dados caso seja edição
    if (editPage) {
      getStoreChangeRequest(idStore).then((resultStore) => {
        const storeData = resultStore.response.storeInfo;

        setLevel(storeData.level ?? 99);
        setDescription(storeData.description ?? null);
        setShowQRCodeStore(storeData.showQRCode ?? null);
        setTitle(storeData.title ?? null);
        setStoreType(storeData.type ?? 'promotion');
        setStoreTypeInitial(storeData.type ?? 'promotion');
        setVoucherPaymentTemplates(storeData.voucherPaymentTemplates ?? []);
        setTypeRescue(storeData.voucherPaymentTemplates ? 'voucher' : 'cost');

        setAutoValidate(storeData?.autoValidate ? 'cliente' : 'estabelecimento');
        setDeliverType(storeData.deliverType ?? 1);
        setCost(storeData.cost ?? 0);
        setIsPublished(storeData.isPublished ?? false);
        setButtonLabel(storeData.buttonLabel ?? '');
        setButtonDescription(storeData.buttonDescription ?? '');
        setShowButtonDescription(storeData.showButtonDescription ?? false);
        setGoToPlaceLabel(storeData.goToPlaceLabel ?? '');
        setShowGoToPlace(storeData.showGoToPlace ?? false);
        setKeywordsSetConsumptionList(storeData.keyWordsSetConsumption ?? []);
        setKeywordsSet(storeData.keyWordsSet ?? []);
        setMessageBlockedKw(storeData.message ?? '');
        setTags(storeData.tags ?? []);

        setPriceInReais(
          Math.round((storeData.cost ?? 0) / 10)
            .toFixed(2)
            .replace('.', ',')
        );
        setStoreThumbnail(storeData.thumbnail ?? null);
        setStorePhoto(storeData.photo ?? null);

        if (storeData.enableDate) {
          //convertendo enable date
          let enableDate = new Date(storeData.enableDate);

          const enableYear = enableDate.getFullYear();
          const enableMonth =
            enableDate.getMonth() + 1 < 10
              ? '0' + (enableDate.getMonth() + 1)
              : enableDate.getMonth() + 1;
          const enableDay =
            enableDate.getDate() < 10 ? '0' + enableDate.getDate() : enableDate.getDate();
          const enableHour =
            enableDate.getHours() < 10 ? '0' + enableDate.getHours() : enableDate.getHours();
          const enableMinute =
            enableDate.getMinutes() < 10 ? '0' + enableDate.getMinutes() : enableDate.getMinutes();

          enableDate =
            enableYear +
            '-' +
            enableMonth +
            '-' +
            enableDay +
            'T' +
            enableHour +
            ':' +
            enableMinute;

          setEnableDate(enableDate);
        }

        if (storeData.disableDate) {
          //convertendo disable date
          let disableDate = new Date(storeData.disableDate);

          const disableYear = disableDate.getFullYear();
          const disableMonth =
            disableDate.getMonth() + 1 < 10
              ? '0' + (disableDate.getMonth() + 1)
              : disableDate.getMonth() + 1;
          const disableDay =
            disableDate.getDate() < 10 ? '0' + disableDate.getDate() : disableDate.getDate();
          const disableHour =
            disableDate.getHours() < 10 ? '0' + disableDate.getHours() : disableDate.getHours();
          const disableMinute =
            disableDate.getMinutes() < 10
              ? '0' + disableDate.getMinutes()
              : disableDate.getMinutes();

          disableDate =
            disableYear +
            '-' +
            disableMonth +
            '-' +
            disableDay +
            'T' +
            disableHour +
            ':' +
            disableMinute;

          setDisableDate(disableDate);
        }

        // Atualizando thumbnail
        if (storeData.thumbnail !== undefined) {
          const folderThumb =
            storeData.type === 'product' ? storeData.thumbnail.split('/')[0] : 'promocao';

          const thumbnailName =
            storeData.type === 'product' && storeData.thumbnail.split('/')[1]
              ? storeData.thumbnail.split('/')[1]
              : storeData.thumbnail;

          downloadImage(folderThumb, thumbnailName).then((downloadedImage) => {
            setFileStoreThumbnail(downloadedImage);
          });
        }

        //atualizando photo
        if (storeData.photo !== undefined) {
          const folderPhoto =
            storeData.type === 'product' ? storeData.photo.split('/')[0] : 'promocao';

          const imgPath =
            storeData.type === 'product' && storeData.photo.split('/')[1]
              ? storeData.photo.split('/')[1]
              : storeData.photo;

          downloadImage(folderPhoto, imgPath).then((loaded) => {
            setFileStorePhoto(loaded);
          });
        }

        // Atualizando photoList
        if (storeData.photoList !== undefined) {
          let photoListFile = [];

          storeData.photoList.map((item, i) => {
            const folderPhotoList = storeData.type === 'product' ? item.split('/')[0] : 'promocao';
            const imgPathList =
              storeData.type === 'product' && item.split('/')[1] ? item.split('/')[1] : item;

            downloadImage(folderPhotoList, imgPathList).then((downloadedImage) => {
              photoListFile[i] = downloadedImage;
              setPhotoListFile(photoListFile);
            });
          });
        }

        //baixando os dados da Voucher Template
        getVoucherTemplate(storeData.templateId).then((dataReceived) => {
          const dataVoucherTemplate = dataReceived.result;

          if (dataVoucherTemplate.thumbnail !== undefined) {
            dataVoucherTemplate.loadedThumbnail = placeholderThumbnail;
            downloadImage('voucher', dataVoucherTemplate.thumbnail).then((downloadedImage) => {
              setThumbnail(dataVoucherTemplate.thumbnail);
              setFileThumbnail(downloadedImage);
            });
          }

          if (dataVoucherTemplate.foto !== undefined) {
            dataVoucherTemplate.loadedFoto = placeholder;
            downloadImage('voucher', dataVoucherTemplate.foto).then((downloadedImage) => {
              setFoto(dataVoucherTemplate.foto);
              setFileFoto(downloadedImage);
            });
          }

          setTemplateInfo(dataVoucherTemplate);
          setId(dataVoucherTemplate.id ?? storeData.templateId);

          setRegion(dataVoucherTemplate.region ?? 'local');
          setHasSimultaneo(dataVoucherTemplate.qtdSimultaneo === 1 ? false : true);
          setQtdSimultaneo(dataVoucherTemplate.qtdSimultaneo ?? 1);
          setNomeTemplate(dataVoucherTemplate.nomeTemplate);
          setPlural(dataVoucherTemplate.plural);
          setSingular(dataVoucherTemplate.singular);
          setTitulo(dataVoucherTemplate.titulo);
          setDetailsTitle(dataVoucherTemplate.detailsTitle);
          setDescricao(dataVoucherTemplate.descricao);
          setDetailsDescription(dataVoucherTemplate.detailsDescription);
          setCredit(dataVoucherTemplate.credit);
          setConsumerHelpText(dataVoucherTemplate.consumerHelpText);
          setShowQrCodeVoucher(dataVoucherTemplate.showQrCode ?? false);
          setType(dataVoucherTemplate.type);
          setConsumo(storeData.showQRCode ? 'imediato' : 'posterior');
          setConsumoUnico(dataVoucherTemplate.consumoUnico ?? false);
          setCouponGetMode(dataVoucherTemplate.couponGetMode ?? 'simpleGetMode');
          setDataGeracao(dataVoucherTemplate.dataGeracao);
          setQtdDisponivel(dataVoucherTemplate.qtdDisponivel ?? 0);
          setConsumed(dataVoucherTemplate.consumed ?? false);

          setCampanhaTriibo(dataVoucherTemplate.campanhaTriibo);
          setSendSMS(dataVoucherTemplate.sendSMS);
          setGenerator(dataVoucherTemplate.generator);
          setShowVoucherCodes(dataVoucherTemplate.showVoucherCodes);

          // convert milliseconds to day
          setOnSendExpiration(dataVoucherTemplate.onSendExpiration / 86400000 || 1);
          setDisableDateCoupon(convertIsoToDate(new Date(dataVoucherTemplate.disableDate)) || null);

          setFoto(dataVoucherTemplate.foto);
          setThumbnail(dataVoucherTemplate.thumbnail);

          const cooldown = msToTime(dataVoucherTemplate.cooldown);

          setCooldownDays(!cooldown.days || cooldown.days === NaN ? 0 : cooldown.days);
          setCooldownHours(!cooldown.hours || cooldown.hours === NaN ? 0 : cooldown.hours);
          setCooldownMinutes(!cooldown.minutes || cooldown.minutes === NaN ? 0 : cooldown.minutes);

          setLoading(false);
        });
      });
    } else {
      setLoading(false);
    }

    if (idEstabelecimento) {
      getStoreByEstablishment(idEstabelecimento, 0, 10000, true)
        .then((res) => {
          const storeInfos = res
            .map((item) => {
              const [key] = Object.keys(item);
              return item[key]?.storeInfo;
            })
            .filter(Boolean);

          setDataStoreByEstablishment(storeInfos);
        })
        .catch((error) => console.error('Ocorreu um erro na getStoreByEstablishment', error));
    }
  }, []);

  //altera os states dos campos, caso o usuário insira informações nos input
  const handleChange = (setter) => (event) => {
    const value = event.target.value;

    // Se o setter for setTypeRescue
    if (setter === setTypeRescue) {
      if (value === 'cost') {
        setVoucherPaymentTemplates([]);
      }

      if (value === 'voucher') {
        setCost(0);
        setPriceInReais(0);
      }

      setter(value);
      setGoBack(true);
      return;
    }

    // Se for cost (evita valores negativos)
    if (setter === setCost) {
      if (value < 0) return;

      handleCalculationValueProduct(value);

      const currencyValue = value ? parseInt(value.replace(/\D+/g, '')) : 0;
      setPriceInReais(currencyValue);
      setGoBack(true);

      // setter(value);
      return;
    }

    // Validação específica para qtdSimultaneo
    if (setter === setQtdSimultaneo) {
      setGoBack(true);

      const newValue = value < 1 ? 1 : value;
      setter(newValue);
      setGoBack(true);

      if (value < 1) toast.error('Este valor não pode ser menor que 1.');
      return;
    }

    // Validação específica para level
    if (setter === setLevel) {
      const parsedValue = parseInt(value);
      const isInvalid = parsedValue > 99 || parsedValue < 1;

      setter(isInvalid ? level : parsedValue);
      setGoBack(true);

      if (isInvalid) toast.error('O nível da hierarquia deve ser entre 1 e 99.');
      return;
    }

    // Validação para cooldownHours e cooldownMinutes
    if (setter === setCooldownHours || setter === setCooldownMinutes || setter === setCredit) {
      const parsedValue = parseInt(value);
      let finalValue = parsedValue;

      if (setter === setCooldownMinutes && parsedValue > 59) {
        finalValue = 59;
      } else if (setter === setCooldownHours && parsedValue > 23) {
        finalValue = 23;
      } else if (parsedValue < 0) {
        finalValue = 0;
        toast.error('Este valor não pode ser negativo.');
      }

      setGoBack(true);
      setter(finalValue);
      return;
    }

    // Quando o campo muda para 'imediato' ou 'posterior'
    if (value === 'imediato') {
      setter(value);
      setConsumo('imediato');
      setShowQRCodeStore(true);
      setOnSendExpiration(null);
      setDisableDateCoupon(null);
      setGoBack(true);
      return;
    }

    if (value === 'posterior') {
      setter(value);
      setConsumo('posterior');
      setShowQRCodeStore(null);
      setDisableDateCoupon(convertIsoToDate(new Date(Date.now() + 86400000 * 365)));
      setGoBack(true);
      return;
    }

    // Valor padrão
    setter(value);
    setGoBack(true);
  };

  //handle downshift
  const handleChangeDownshiftConsume = (item) => {
    let keywordsSetConsumptionListAux = keywordsSetConsumptionList;

    if (keywordsSetConsumptionListAux.indexOf(item) === -1) {
      keywordsSetConsumptionListAux = [...keywordsSetConsumptionListAux, item];
    }

    setKeywordsSetConsumption('');
    setKeywordsSetConsumptionList(keywordsSetConsumptionListAux);
  };

  const handleDeleteDownshiftConsume = (item) => {
    setKeywordsSetConsumptionList((prevList) => {
      const newList = [...prevList];
      newList.splice(newList.indexOf(item), 1);
      return newList;
    });
  };

  const handleChangeDownshift = (item) => {
    setKeywordsSet((prevList) => {
      if (!prevList.includes(item)) {
        return [...prevList, item];
      }
      return prevList;
    });
    setKeywords('');
  };

  const handleDeleteDownshift = (item) => {
    setKeywordsSet((prevList) => {
      const newList = [...prevList];
      newList.splice(newList.indexOf(item), 1);
      return newList;
    });
  };

  const handlePushTag = () => {
    let tagHolder = tags;
    if (tagHolder.indexOf(tagCapture.toLocaleLowerCase()) === -1 && tagCapture.length !== 0) {
      tagHolder.push(tagCapture.toLowerCase());
    }

    setTags([...tagHolder]);
    setTagCapture('');
    setGoBack(true);
  };

  const handleCalculationValueProduct = (price) => {
    const maskRemovedPrice = price.replace(',', '.');

    const valueInPercentage = maskRemovedPrice * 10;
    const finalPrice = Math.round(valueInPercentage);

    setCost(finalPrice);
  };

  const addComma = () => {
    if (priceInReais > 0) {
      const newValue = priceInReais + ',00';

      setPriceInReais(newValue);
    }
  };

  const removeComma = () => {
    if (priceInReais) {
      const newValue = priceInReais.replace(',00', '');

      setPriceInReais(newValue);
    }
  };

  const goBackFunc = () => {
    if (goBack === false) {
      history.goBack();
    } else {
      setOpenDialogGoBack(true);
    }
  };

  const checkInformation = async (e) => {
    e.preventDefault();
    setOpenDialog(false);

    if (!fileStoreThumbnail || fileStoreThumbnail === '') {
      toast.error('É necessário adicionar uma imagem de thumbnail.');
    } else if (!fileStorePhoto || fileStorePhoto === '') {
      toast.error('É necessário adicionar ao menos uma imagem na lista de fotos.');
    } else if ((!fileThumbnail || fileThumbnail === '') && !sameImages) {
      toast.error('É necessário adicionar uma imagem de thumbnail para o cupom.');
    } else if ((!fileFoto || fileFoto === '') && !sameImages) {
      toast.error('É necessário adicionar uma imagem de detalhe para o cupom');
    } else if (
      typeRescue === 'voucher' &&
      voucherPaymentTemplates.length === 0 &&
      storeType === 'product'
    ) {
      toast.error('É necessário adicionar um id de voucher.');
    } else if (tags.length < 1) {
      toast.error('É necessário adicionar ao menos uma tag.');
    } else {
      setLoading(true);

      //convertendo imagens do cupom
      let newFileThumbnail = fileThumbnail;
      let newFileFoto = fileFoto;

      if (sameImages) {
        if (isBase64(fileStoreThumbnail)) {
          newFileThumbnail = fileStoreThumbnail;
        } else {
          newFileThumbnail = await downloadImageAsBlob(fileStoreThumbnail);
          newFileThumbnail = await blobToBase64(newFileThumbnail);
        }

        if (isBase64(fileStorePhoto)) {
          newFileFoto = fileStorePhoto;
        } else {
          newFileFoto = await downloadImageAsBlob(fileStorePhoto);
          newFileFoto = await blobToBase64(newFileFoto);
        }
      }

      let newFileStoreThumbnail = fileStoreThumbnail;
      let newFileStorePhoto = fileStorePhoto;
      let newPhotoListFile = [];

      //tratando se tipo da promoção mudou
      if (storeType !== storeTypeInitial) {
        if (!isBase64(fileStoreThumbnail)) {
          newFileStoreThumbnail = await downloadImageAsBlob(newFileStoreThumbnail);
          newFileStoreThumbnail = await blobToBase64(newFileStoreThumbnail);
        }

        if (!isBase64(fileStorePhoto)) {
          newFileStorePhoto = await downloadImageAsBlob(newFileStorePhoto);
          newFileStorePhoto = await blobToBase64(newFileStorePhoto);
        }

        await Promise.all(
          photoListFile.map(async (item, i) => {
            if (!isBase64(item)) {
              item = await downloadImageAsBlob(item);
              item = await blobToBase64(item);
            }
            newPhotoListFile.push(item);
          })
        );
      } else newPhotoListFile = photoListFile;

      try {
        await updateStorePromotionInformationAction({
          id,
          consumoUnico,
          cooldownMinutes,
          cooldownHours:
            parseInt(cooldownHours, 10) + parseInt(24 * parseInt(cooldownDays, 10), 10),
          dataGeracao,
          descricao,
          detailsDescription,
          credit,
          detailsTitle,
          generator,
          neighborhood,
          nomeTemplate,
          plural,
          qtdSimultaneo,
          singular,
          titulo,
          type,
          fileThumbnail: newFileThumbnail,
          thumbnail,
          fileFoto: newFileFoto,
          foto,
          campanhaTriibo,
          consumed,
          cost,
          sendSMS,
          hasSimultaneo: Number(hasSimultaneo),
          couponGetMode,
          consumerHelpText,
          showQrCodeVoucher,
          showVoucherCodes,
          expirationType,
          disableDateCoupon,
          onSendExpiration,
          templateInfo,

          idStore,
          description,
          showQRCodeStore,
          title,
          storeType,
          autoValidate,
          enableDate,
          disableDate,
          tags,
          voucherPaymentTemplates,
          level,
          region,
          deliverType,
          isPublished,
          keyWordsSet,
          keywordsSetConsumptionList,
          messageBlockedKw,
          buttonLabel,
          buttonDescription,
          showButtonDescription,
          goToPlaceLabel,
          showGoToPlace,
          fileStoreThumbnail: newFileStoreThumbnail,
          storeThumbnail,
          fileStorePhoto: newFileStorePhoto,
          storePhoto,
          photoListFile: newPhotoListFile,

          idEstabelecimento,
          idGestor,
          nomeEstabelecimento,
          lat,
          long,
          address,
        });

        setLoading(false);
        history.goBack();
      } catch (error) {
        console.error('Erro ao atualizar as informações da promoção:', error);
        setLoading(false);
        toast.error(error?.response?.data?.error ?? 'Ocorreu um erro.');
      }
    }
  };

  const removeImage = (idx) => {
    let photoListFileAux = [...(photoListFile ?? [])];
    photoListFileAux.splice(idx, 1);

    setPhotoListFile(photoListFileAux);
    setGoBack(true);
  };

  const mainImage = (idx) => {
    let currentFoto = fileStorePhoto;
    let newPhotoListFile = photoListFile;
    let newFoto = photoListFile[idx];

    newPhotoListFile.splice(idx, 1);
    newPhotoListFile.unshift(currentFoto);

    setPhotoListFile(newPhotoListFile);
    setFileStorePhoto(newFoto);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataReceived = await getKeywords();

        suggestions = dataReceived.map((item) => ({
          label: item.value,
        }));
      } catch (error) {
        console.error('Erro na data:', error);
      }
    };

    fetchData();
  }, []);

  const copyTemplateIdToClipboard = () => {
    navigator.clipboard.writeText(id);
    toast.success('ID copiado com sucesso');
  };

  // Função para adicionar um template de pagamento
  const handleAddChip = (templateId) => {
    if (templateId && !voucherPaymentTemplates.includes(templateId)) {
      setVoucherPaymentTemplates((prevState) => [...prevState, templateId]);
    }
  };

  // Função para remover um template de pagamento
  const handleDeleteChipVoucher = (chipToDelete) => () => {
    setVoucherPaymentTemplates((prevState) => prevState.filter((chip) => chip !== chipToDelete));
  };

  const photoListChangeStore = (file) => {
    if (fileStorePhoto === '') {
      setFileStorePhoto(file);
    } else {
      let photoListFileAux = [...(photoListFile ?? [])];
      if (file !== '') photoListFileAux.push(file);

      setPhotoListFile(photoListFileAux);
    }
  };

  const options = dataStoreByEstablishment?.map((item) => ({
    id: item.id,
    title: item.title,
    templateId: item.templateId,
  }));

  if (loading)
    return (
      <div className="loading">
        <Loading />
      </div>
    );
  else {
    return (
      <div
        style={{
          maxHeight: '100%',
          overflowY: 'auto',
          padding: '35px 22px',
          maxWidth: '100%',
        }}
      >
        <AreaHeader
          style={{
            color: '#08bad0',
            justifyContent: 'end',
          }}
        >
          <GoBack onClick={() => goBackFunc()}>
            <ArrowLeft /> Voltar
          </GoBack>
        </AreaHeader>
        {idStore === null ? (
          <Typography
            variant="h5"
            gutterBottom
            color="primary"
            style={{ fontWeight: '700', fontSize: '25px' }}
          >
            Cadastro da oferta
          </Typography>
        ) : (
          <EditShowId text="Editar Oferta" id={idStore} />
        )}
        <TextField
          variant="outlined"
          className="input-field"
          type="text"
          value={title === null ? '' : title}
          id="title"
          label="Título da Oferta"
          onChange={handleChange(setTitle)}
          required
        />
        <TextField
          variant="outlined"
          className="input-field"
          multiline
          type="text"
          value={description === null ? '' : description}
          id="description"
          required
          label="Descrição da Oferta"
          onChange={handleChange(setDescription)}
        />
        <TextField
          variant="outlined"
          style={{ width: '300px' }}
          className="input-field"
          onChange={handleChange(setLevel)}
          value={level}
          type="number"
          id="level"
          required={isPublished}
          label="Hierarquia da Oferta"
        />
        <br />
        <Downshift
          id="downshift-multiple"
          inputValue={keywords}
          onChange={handleChangeDownshift}
          selectedItem={keyWordsSet}
          style={{ width: '100%' }}
        >
          {({
            getInputProps,
            getItemProps,
            isOpen,
            inputValue: inputValue2,
            selectedItem: selectedItem2,
            highlightedIndex,
          }) => (
            <div style={{ width: '100%', marginTop: '1em' }}>
              {renderInput({
                fullWidth: true,
                InputProps: getInputProps({
                  startAdornment: keyWordsSet.map((item) => (
                    <Chip
                      key={item}
                      tabIndex={-1}
                      label={item}
                      onDelete={() => handleDeleteDownshift(item)}
                    />
                  )),
                  onChange: (e) => {
                    setKeywords(e.target.value);
                    setGoBack(true);
                  },
                  placeholder: 'Selecione a keyword na lista abaixo',
                }),
                label: 'Keywords',
              })}
              {isOpen ? (
                <Paper square>
                  {getSuggestions(inputValue2).map((suggestion, index) =>
                    renderSuggestion({
                      suggestion,
                      index,
                      itemProps: getItemProps({ item: suggestion.label }),
                      highlightedIndex,
                      selectedItem: selectedItem2,
                    })
                  )}
                </Paper>
              ) : null}
            </div>
          )}
        </Downshift>
        <div style={{ paddingTop: '30px' }}>
          <div>
            <S.TagsLabelContainer>
              <S.TagsBigLabel>Tags da oferta</S.TagsBigLabel>
              <S.TagsSmallLabel>
                As tags auxiliam na classificação e busca do seu negócio dentro do App. Adicione uma
                palavra por vez.
              </S.TagsSmallLabel>
            </S.TagsLabelContainer>

            <S.TagsContainer>
              <S.TagsAddContainer>
                <D.TriiboTextField
                  rows={1}
                  placeholder={'Insira o tipo e aperte enter'}
                  value={tagCapture}
                  onChange={(e) => {
                    setTagCapture(e.target.value.trim());
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handlePushTag();
                    }
                  }}
                />
                <S.TagsAddButton
                  blue={true}
                  onClick={(e) => {
                    e.preventDefault();
                    handlePushTag();
                  }}
                >
                  Adicionar tag
                </S.TagsAddButton>
              </S.TagsAddContainer>
              <D.TriiboTagsField>
                <D.TriiboTagsPlaceholder $visibility={tags.length === 0 ? false : true}>
                  Digite a tag desejada no campo acima e pressione o botão para adicioná-las
                </D.TriiboTagsPlaceholder>
                {tags.length > 0 &&
                  tags.map((body, index) => (
                    <D.UserTags key={index}>
                      <D.TagText>{body}</D.TagText>
                      <D.TagDelete
                        onClick={(e) => {
                          e.preventDefault();
                          let newArr = tags;
                          newArr.splice(index, 1);

                          setTags([...newArr]);
                        }}
                      >
                        {<BsXLg style={{ color: 'white' }} />}
                      </D.TagDelete>
                    </D.UserTags>
                  ))}
              </D.TriiboTagsField>
            </S.TagsContainer>
          </div>
        </div>
        <br /> <br />
        {/* FOTOS DA PROMOCAO */}
        <Typography
          style={{
            marginTop: '10px',
            marginBottom: '-15px',
            fontWeight: '700',
            fontSize: '20px',
          }}
          variant="h5"
          gutterBottom
          color="primary"
        >
          Fotos da promoção
        </Typography>
        <br />
        <br />
        <div className="flex-external">
          <div
            className="img-thumb"
            style={{
              maxWidth: '400px',
              position: 'relative',
              top: '0',
              left: '0',
            }}
          >
            <Typography
              variant="subtitle2"
              gutterBottom
              color="secondary"
              style={{ fontWeight: '550', textAlign: 'center' }}
            >
              Thumbnail (aparecerá em "Promoções Próximas")
            </Typography>

            <img
              src={thumbnailPromocao}
              alt="Thumbnail"
              style={{
                width: '100%',
                maxWidth: '400px',
                maxHeight: '447px',
                position: 'relative',
                top: '0',
                left: '0',
              }}
            />

            <img
              className="img-position-simples"
              alt="thumbnail"
              src={
                !fileStoreThumbnail || fileStoreThumbnail === '' ? placeholder : fileStoreThumbnail
              }
            />

            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <ImportImage
                imageDefault={null}
                autoWidth={true}
                image={fileStoreThumbnail ?? ''}
                setImage={setFileStoreThumbnail}
                ratio={4 / 3}
              />
            </div>
          </div>

          {/* Lista de fotos */}
          <div>
            <Typography
              variant="subtitle2"
              gutterBottom
              color="secondary"
              className="style-text"
              style={{ fontWeight: '550' }}
            >
              Lista de Fotos (aparecerá em "Detalhe da Oferta")
            </Typography>

            <section className="grid-style">
              <div
                className="Foto-detalhe"
                style={{
                  width: '100%',
                  maxWidth: '400px',
                  position: 'relative',
                  top: '0',
                  left: '0',
                }}
              >
                <img
                  alt="Lista de Fotos"
                  src={listaFotos}
                  style={{
                    width: '100%',
                    maxWidth: '392px',
                    position: 'relative',
                    top: '0',
                    left: '0',
                  }}
                />

                <StyledBadge2
                  style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    height: '100%',
                    width: '100%',
                  }}
                  badgeContent={
                    <Tooltip
                      title={
                        fileStorePhoto && fileStorePhoto[0]
                          ? 'Para trocar clique em uma imagem ao lado'
                          : 'Utilize o botão "Adicionar fotos"'
                      }
                      style={{ height: '100%', width: '100%' }}
                    >
                      <Help color="secondary" style={{ fontSize: 18 }} />
                    </Tooltip>
                  }
                  color="primary"
                >
                  <img
                    src={!fileStorePhoto || fileStorePhoto === '' ? placeholder : fileStorePhoto}
                    alt="lista de fotos"
                    width="100%"
                    style={{
                      maxWidth: '393px',
                      position: 'absolute',
                      top: '0',
                      left: '0',
                    }}
                  />
                </StyledBadge2>
              </div>

              <div className="lista-detalhes" id="photoList">
                {photoListFile.map((item, i) => {
                  return (
                    <Grid key={i} item md={10} style={{ marginBottom: '15px' }}>
                      <StyledBadge
                        badgeContent={
                          <Tooltip title="Excluir">
                            <Close
                              style={{ width: '100%', height: '100%' }}
                              onClick={() => removeImage(i)}
                            />
                          </Tooltip>
                        }
                      >
                        <Tooltip title={'Tornar principal'}>
                          <img
                            style={{ cursor: 'pointer' }}
                            onClick={() => mainImage(i)}
                            src={item ?? placeholder}
                            width="100%"
                            height="100%"
                            alt="Lista de Fotos"
                          />
                        </Tooltip>
                      </StyledBadge>
                    </Grid>
                  );
                })}
              </div>
            </section>

            <div style={{ display: 'flex', justifyContent: 'left' }}>
              <ImportImage
                imageDefault={null}
                autoWidth={false}
                image={''}
                setImage={photoListChangeStore}
                ratio={4 / 3}
              />
            </div>
          </div>
        </div>
        {/* FIM FOTOS DA PROMOCAO */}
        <Typography
          style={{ marginTop: '20px', fontWeight: '700' }}
          variant="h5"
          gutterBottom
          color="primary"
        >
          Dados da carteira
        </Typography>
        {idStore !== null ? (
          <Box display="flex">
            <Button
              variant="contained"
              color="primary"
              component="span"
              style={{
                fontWeight: '550',
                color: '#fff',
                textTransform: 'capitalize',
              }}
              startIcon={<FileCopy />}
              onClick={() => copyTemplateIdToClipboard()}
            >
              Copiar ID do template
            </Button>
          </Box>
        ) : (
          <></>
        )}
        <br />
        <TextField
          variant="outlined"
          className="input-field"
          value={nomeTemplate === null ? '' : nomeTemplate}
          onChange={handleChange(setNomeTemplate)}
          type="text"
          id="singular"
          required
          label="Nome do Template"
        />
        <TextField
          variant="outlined"
          className="input-field"
          value={singular === null ? '' : singular}
          onChange={handleChange(setSingular)}
          type="text"
          id="singular"
          required={isPublished}
          label="Objeto da Carteira no singular"
        />
        <TextField
          variant="outlined"
          className="input-field"
          value={plural === null ? '' : plural}
          onChange={handleChange(setPlural)}
          type="text"
          id="plural"
          required={isPublished}
          label="Objeto da Carteira no plural"
        />
        <TextField
          variant="outlined"
          className="input-field"
          value={titulo === null ? '' : titulo}
          type="text"
          id="titulo"
          required
          label="Título"
          onChange={handleChange(setTitulo)}
        />
        <TextField
          variant="outlined"
          className="input-field"
          value={detailsTitle === null ? '' : detailsTitle}
          onChange={handleChange(setDetailsTitle)}
          type="text"
          id="detailsTitle"
          label="Detalhe do Título"
        />
        <TextField
          variant="outlined"
          className="input-field"
          value={descricao === null ? '' : descricao}
          multiline
          onChange={handleChange(setDescricao)}
          type="text"
          id="descricao"
          required
          label="Descrição"
        />
        <TextField
          variant="outlined"
          className="input-field"
          value={detailsDescription === null ? '' : detailsDescription}
          multiline
          onChange={handleChange(setDetailsDescription)}
          type="text"
          id="detailsDescription"
          label="Detalhe da Descrição"
        />
        <TextField
          variant="outlined"
          className="input-field"
          value={credit === null ? '' : credit}
          onChange={handleChange(setCredit)}
          onWheel={(e) => e.target.blur()}
          type="number"
          id="credit"
          label="Crédito"
        />
        <br />
        <Downshift
          id="downshift-multiple"
          inputValue={keywordsSetConsumption}
          onChange={handleChangeDownshiftConsume}
          selectedItem={keywordsSetConsumptionList}
          style={{ width: '100%' }}
        >
          {({
            getInputProps,
            getItemProps,
            isOpen,
            inputValue: inputValue3,
            selectedItem: selectedItem3,
            highlightedIndex,
          }) => (
            <div style={{ width: '100%', marginTop: '1em' }}>
              {renderInput({
                fullWidth: true,
                InputProps: getInputProps({
                  startAdornment: keywordsSetConsumptionList.map((item) => (
                    <Chip
                      key={item}
                      tabIndex={-1}
                      label={item}
                      onDelete={() => handleDeleteDownshiftConsume(item)}
                    />
                  )),
                  onChange: (e) => {
                    setKeywordsSetConsumption(e.target.value);
                    setGoBack(true);
                  },
                  placeholder: 'Selecione as keywords de consumo',
                }),
                label: 'Keywords de consumo',
              })}
              {isOpen ? (
                <Paper square>
                  {getSuggestions(inputValue3).map((suggestion, index) =>
                    renderSuggestion({
                      suggestion,
                      index,
                      itemProps: getItemProps({ item: suggestion.label }),
                      highlightedIndex,
                      selectedItem: selectedItem3,
                    })
                  )}
                </Paper>
              ) : null}
            </div>
          )}
        </Downshift>
        <TextField
          style={{ width: '100%' }}
          placeholder="Você não tem essa permissão !"
          className="input-field"
          disabled={keywordsSetConsumptionList <= 0}
          value={messageBlockedKw === null ? '' : messageBlockedKw}
          multiline
          onChange={handleChange(setMessageBlockedKw)}
          type="text"
          id="messageBlockedKw"
          required={keywordsSetConsumptionList > 0}
          label="Mensagem de bloqueio por keyword"
        />
        <TextField
          style={{ width: '100%' }}
          className="input-field"
          value={consumerHelpText === null ? '' : consumerHelpText}
          multiline
          onChange={handleChange(setConsumerHelpText)}
          type="text"
          id="consumerHelpText"
          label="Texto de ajuda para o consumidor"
        />
        <FormControlLabel
          control={
            <Switch
              checked={campanhaTriibo}
              onChange={(e) => {
                setCampanhaTriibo(e.target.checked);
                setGoBack(true);
              }}
              color="primary"
            />
          }
          label={'Campanha Triibo?'}
        />
        <FormControlLabel
          control={
            <Switch
              checked={sendSMS}
              onChange={(e) => {
                setSendSMS(e.target.checked);
                setGoBack(true);
              }}
              color="primary"
            />
          }
          label={'Enviar SMS ao resgatar a promoção?'}
        />
        <FormControlLabel
          control={
            <Switch
              checked={showQrCodeVoucher}
              onChange={(e) => {
                setShowQrCodeVoucher(e.target.checked);
                setGoBack(true);
              }}
              color="primary"
            />
          }
          label={'Mostrar QR Code'}
        />
        <FormControlLabel
          control={
            <Switch
              checked={showVoucherCodes}
              onChange={(e) => {
                setShowVoucherCodes(e.target.checked);
                setGoBack(true);
              }}
              color="primary"
            />
          }
          label={'Mostrar códigos de voucher'}
        />
        <br />
        <FormControlLabel
          control={
            <Switch
              checked={sameImages}
              onChange={() => {
                setSameImages(!sameImages);
                setGoBack(true);
              }}
              color="primary"
            />
          }
          label={'Utilizar as mesmas imagens da promoção'}
        />
        {!sameImages && (
          <Typography
            style={{
              marginTop: '10px',
              marginBottom: '15px',
              fontWeight: '700',
              fontSize: '20px',
            }}
            variant="h5"
            gutterBottom
            color="primary"
          >
            Fotos do cupom na carteira
          </Typography>
        )}
        {!sameImages && (
          <div className="flex-external">
            <div
              className="img-thumb"
              style={{
                maxWidth: '400px',
                position: 'relative',
                top: '0',
                left: '0',
              }}
            >
              <Typography
                variant="subtitle2"
                gutterBottom
                color="secondary"
                style={{ fontWeight: '550', textAlign: 'center' }}
              >
                Thumbnail (aparecerá na "Carteira")
              </Typography>

              <img
                alt="Thumbnail"
                src={cuponsValidos}
                style={{
                  width: '100%',
                  maxWidth: '400px',
                  position: 'relative',
                  top: '0',
                  left: '0',
                }}
              />

              <img
                alt="thumbnail"
                className="img-position-carteira"
                src={!fileThumbnail || fileStoreThumbnail === '' ? placeholder : fileThumbnail}
              />

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <ImportImage
                  imageDefault={fileThumbnail ?? ''}
                  autoWidth={false}
                  image={fileThumbnail}
                  setImage={setFileThumbnail}
                  ratio={4 / 3}
                />
              </div>
            </div>

            <div
              className="img-thumb"
              style={{
                maxWidth: '400px',
                position: 'relative',
                top: '0',
                left: '0',
              }}
            >
              <Typography
                variant="subtitle2"
                gutterBottom
                color="secondary"
                style={{ fontWeight: '550', textAlign: 'center' }}
              >
                Foto detalhada (aparecerá em "Detalhe do Cupom")
              </Typography>

              <img
                alt="Placeholder lista img"
                src={nomeCupom}
                style={{
                  maxWidth: '100%',
                  position: 'relative',
                  top: '0',
                  left: '0',
                }}
              />

              <img
                alt="Foto detalhada"
                width="100%"
                style={{ position: 'absolute', left: '0' }}
                src={!fileFoto || fileFoto === '' ? placeholder : fileFoto}
              />

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <ImportImage
                  imageDefault={null}
                  autoWidth={false}
                  image={fileFoto ?? ''}
                  setImage={setFileFoto}
                  ratio={4 / 3}
                />
              </div>
            </div>
          </div>
        )}
        <Grid
          style={{
            maxHeight: '100%',
            overflowY: 'auto',
            padding: '40px 32px',
          }}
          container
          spacing={4}
        >
          <FormLabel style={{ marginTop: '20px' }} component="legend">
            Selecione a região da promoção (ordenação na lista)
          </FormLabel>
          <FormControl className="input-field">
            <Select
              variant="outlined"
              className="input-field"
              value={region}
              onChange={handleChange(setRegion)}
              displayEmpty
              name="region"
            >
              <MenuItem value="regional">Regional</MenuItem>
              <MenuItem value="national">Nacional</MenuItem>
              <MenuItem value="local">Local</MenuItem>
            </Select>
          </FormControl>

          <FormLabel style={{ marginTop: '20px' }} component="legend">
            Tipo de Consumo
          </FormLabel>
          <FormControl className="input-field">
            <RadioGroup
              aria-label="consumo"
              name="consumo"
              value={consumo}
              onChange={handleChange(setConsumo)}
            >
              <FormControlLabel
                value="imediato"
                control={<Radio color="primary" />}
                label="Imediato"
                labelPlacement="end"
              />

              <FormControlLabel
                value="posterior"
                control={<Radio color="primary" />}
                label="Posterior"
                labelPlacement="end"
              />
            </RadioGroup>
            <FormLabel style={{ marginTop: '20px', marginBottom: '10px' }} component="legend">
              Validade do cupom
            </FormLabel>
            <RadioGroup
              aria-label="validade do cupom"
              name="validateCuopon"
              value={expirationType}
              onChange={(e) => setExpirationType(e.target.value)}
            >
              <FormControlLabel
                value="fixed"
                control={<Radio color="primary" />}
                label="Data de desativação"
                disabled={consumo === 'imediato'}
              />
              <FormControlLabel
                value="onSend"
                control={<Radio color="primary" />}
                label="Validade em dias (após recebimento na carteira)"
                disabled={consumo === 'imediato'}
              />
            </RadioGroup>
            <br />
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <TextField
                  variant="outlined"
                  id="validateDate"
                  label="Data de desativação"
                  type="datetime-local"
                  value={disableDateCoupon === null ? '' : convertToDate(disableDateCoupon)}
                  InputLabelProps={{ shrink: true }}
                  onChange={handleChange(setDisableDateCoupon)}
                  // required={isPublished}
                  disabled={expirationType === 'onSend' || consumo === 'imediato'}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  variant="outlined"
                  id="validateDays"
                  label="Validade em dias"
                  type="number"
                  style={{ width: '75%' }}
                  InputProps={{ inputProps: { min: 1, max: 365 } }}
                  onInput={(e) =>
                    (e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3))
                  }
                  value={onSendExpiration}
                  InputLabelProps={{ shrink: true }}
                  onChange={handleChange(setOnSendExpiration)}
                  disabled={expirationType === 'fixed' || consumo === 'imediato'}
                />
              </Grid>
            </Grid>
            <br />
            <FormControlLabel
              control={
                <Switch
                  disabled={consumo === 'imediato' ? true : false}
                  checked={hasSimultaneo}
                  onChange={(e) => {
                    setHasSimultaneo(e.target.checked);
                    setGoBack(true);
                  }}
                  color="primary"
                />
              }
              label={'Permite resgate simultâneo?'}
            />

            <TextField
              variant="outlined"
              style={{ width: '100px' }}
              className="input-field"
              disabled={consumo === 'imediato' || hasSimultaneo === false}
              onChange={handleChange(setQtdSimultaneo)}
              value={qtdSimultaneo === null ? '' : qtdSimultaneo}
              type="number"
              id="qtdSimultaneo"
              required={isPublished}
              label="Quantidade Simultaneo"
            />

            <TextField
              variant="outlined"
              className="input-field"
              value={buttonLabel === null ? '' : buttonLabel}
              multiline
              onChange={handleChange(setButtonLabel)}
              type="text"
              id="buttonLabel"
              label="Texto do botão"
            />

            <TextField
              variant="outlined"
              className="input-field"
              value={buttonDescription === null ? '' : buttonDescription}
              multiline
              onChange={handleChange(setButtonDescription)}
              type="text"
              id="buttonDescription"
              label="Descrição do botão"
            />

            <FormControlLabel
              control={
                <Switch
                  checked={showButtonDescription}
                  onChange={(e) => {
                    setShowButtonDescription(e.target.checked);
                    setGoBack(true);
                  }}
                  color="primary"
                />
              }
              label={'Mostrar descrição do botão?'}
            />

            <TextField
              variant="outlined"
              className="input-field"
              value={goToPlaceLabel === null ? '' : goToPlaceLabel}
              multiline
              onChange={handleChange(setGoToPlaceLabel)}
              type="text"
              id="goToPlaceLabel"
              label="Texto do botão para o estabelecimento"
            />

            <FormControlLabel
              control={
                <Switch
                  checked={showGoToPlace}
                  onChange={(e) => {
                    setShowGoToPlace(e.target.checked);
                    setGoBack(true);
                  }}
                  color="primary"
                />
              }
              label={'Mostrar botão de visualizar estabelecimento?'}
            />

            <FormLabel style={{ marginTop: '20px' }} component="legend">
              Processo de Validação
            </FormLabel>

            <RadioGroup
              aria-label="autoValidate"
              name="autoValidate"
              value={autoValidate}
              onChange={handleChange(setAutoValidate)}
            >
              <FormControlLabel
                value="estabelecimento"
                control={<Radio color="primary" />}
                label="Celular do Estabelecimento"
                labelPlacement="end"
              />

              <FormControlLabel
                value="cliente"
                control={<Radio color="primary" />}
                label="Celular do Cliente"
                labelPlacement="end"
              />
            </RadioGroup>

            <FormControlLabel
              style={{ marginTop: '10px', marginBottom: '-20px' }}
              control={
                <Switch
                  checked={consumoUnico}
                  onChange={(e) => {
                    setConsumoUnico(e.target.checked);
                    setGoBack(true);
                  }}
                  color="primary"
                />
              }
              label={'Voucher de Consumo único?'}
            />
            <FormControlLabel
              style={{ marginTop: '7px', marginBottom: '-20px' }}
              control={
                <Switch
                  checked={consumed}
                  onChange={(e) => {
                    setConsumed(e.target.checked);
                    setGoBack(true);
                  }}
                  color="primary"
                />
              }
              label={'Consumir promoção automaticamente?'}
            />

            <FormLabel style={{ marginTop: '40px' }} component="legend">
              Tempo de espera para pegar outro cupom
            </FormLabel>

            <Grid container spacing={4}>
              <Grid item lg={1}>
                <TextField
                  variant="outlined"
                  style={{ width: '70px' }}
                  className="input-field"
                  value={cooldownDays === null ? '' : cooldownDays}
                  onChange={handleChange(setCooldownDays)}
                  type="number"
                  id="cooldownDays"
                  required={isPublished}
                  label="Dias"
                />
              </Grid>
              <Grid item lg={1}>
                <TextField
                  variant="outlined"
                  style={{ width: '70px' }}
                  className="input-field"
                  value={cooldownHours === null ? '' : cooldownHours}
                  onChange={handleChange(setCooldownHours)}
                  type="number"
                  id="cooldownHours"
                  required={isPublished}
                  label="Horas"
                />
              </Grid>
              <Grid item lg={1}>
                <TextField
                  variant="outlined"
                  style={{ width: '70px' }}
                  className="input-field"
                  value={cooldownMinutes === null ? '' : cooldownMinutes}
                  onChange={handleChange(setCooldownMinutes)}
                  type="number"
                  id="cooldownMinutes"
                  required={isPublished}
                  label="Minutos"
                />
              </Grid>
            </Grid>

            <FormControlLabel
              style={{ marginTop: '10px' }}
              control={
                <Switch
                  checked={generator}
                  onChange={(e) => {
                    setGenerator(e.target.checked);
                    setGoBack(true);
                  }}
                  color="primary"
                  disabled={qtdDisponivel !== null && qtdDisponivel !== 0}
                />
              }
              label={'Estoque ilimitado?'}
            />

            {qtdDisponivel !== null && qtdDisponivel !== 0 && editPage && (
              <Typography variant="subtitle2" color="error">
                Você não pode alterar o controle de estoque dessa promoção.
                <br /> Quantidade Disponível: {qtdDisponivel}
              </Typography>
            )}
          </FormControl>

          <Typography style={{ marginTop: '20px' }} variant="h5" gutterBottom color="primary">
            Publicação da Oferta
          </Typography>

          <FormControl className="input-field">
            <FormLabel style={{ marginTop: '20px' }} component="legend">
              Tipo da Oferta
            </FormLabel>
            <RadioGroup
              aria-label="storeType"
              name="storeType"
              value={storeType}
              onChange={handleChange(setStoreType)}
            >
              <FormControlLabel
                value="promotion"
                control={<Radio color="primary" />}
                label="Promoção"
                labelPlacement="end"
              />

              <FormControlLabel
                value="product"
                control={<Radio color="primary" />}
                label="Produto"
                labelPlacement="end"
              />
            </RadioGroup>

            <FormLabel style={{ marginTop: '20px' }} component="legend">
              Selecione o tipo de entrega
            </FormLabel>
            <Select
              variant="outlined"
              className="input-field"
              value={deliverType}
              onChange={handleChange(setDeliverType)}
              displayEmpty
              name="deliverType"
              disabled={storeType === 'promotion' ? true : false}
            >
              <MenuItem value={1}>Retirar no estabelecimento</MenuItem>
              <MenuItem value={0}>Receber pelo correio</MenuItem>
            </Select>

            <div>
              {storeType === 'product' && (
                <>
                  <FormLabel style={{ marginTop: '20px' }} component="legend">
                    O resgate será feito por:
                  </FormLabel>
                  <RadioGroup
                    aria-label="typeRescue"
                    name="typeRescue"
                    value={typeRescue}
                    onChange={handleChange(setTypeRescue)}
                  >
                    <FormControlLabel
                      value="cost"
                      control={<Radio color="primary" />}
                      label="Pontos"
                      labelPlacement="end"
                    />

                    <FormControlLabel
                      value="voucher"
                      control={<Radio color="primary" />}
                      label="Voucher"
                      labelPlacement="end"
                    />
                  </RadioGroup>

                  {typeRescue === 'voucher' && (
                    <div style={{ width: '100%', marginTop: '15px' }}>
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          gap: '10px',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          options={options}
                          getOptionLabel={(option) => `Id: ${option.id} | Título: ${option.title}`}
                          getOptionDisabled={(option) =>
                            voucherPaymentTemplates.includes(option.templateId)
                          } // Desabilita opções já selecionadas
                          sx={{ width: '100%' }}
                          blurOnSelect
                          noOptionsText={'Nenhum resultado encontrado...'}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Selecione uma promoção"
                              onClick={() => setOptionsOpen(true)}
                              onFocus={() => setOptionsOpen(true)}
                              onBlur={() => setOptionsOpen(false)}
                            />
                          )}
                          ListboxProps={{
                            style: { maxHeight: '200px', fontSize: '14px' },
                            sx: { fontSize: '14px' },
                          }}
                          open={optionsOpen}
                          onClose={() => setOptionsOpen(false)}
                          onChange={(event, value) => {
                            if (value && value.templateId) {
                              handleAddChip(value.templateId);
                              setAutocompleteValue(null); // Limpa o Autocomplete
                            }
                          }}
                          value={autocompleteValue}
                        />
                      </Box>

                      <Box mt="25px">
                        <TextField
                          label="Lista de templatesId's adicionados:"
                          multiline
                          rows={3}
                          fullWidth
                          variant="outlined"
                          InputProps={{
                            readOnly: true,
                            startAdornment: (
                              <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{
                                  margin: '4px 0',
                                  minWidth: '100%',
                                }}
                              >
                                {voucherPaymentTemplates.map((template, index) => (
                                  <Chip
                                    key={index}
                                    label={template}
                                    onDelete={handleDeleteChipVoucher(template)}
                                    color="primary"
                                    style={{
                                      color: '#fff',
                                      backgroundColor: '#808080',
                                      margin: '4px',
                                    }}
                                  />
                                ))}
                              </Box>
                            ),
                          }}
                        />
                      </Box>
                    </div>
                  )}
                </>
              )}

              {storeType === 'product' && typeRescue === 'cost' && (
                <>
                  <FormLabel style={{ marginTop: '20px' }} component="legend" color="primary">
                    Por quanto você quer vender esse produto?
                  </FormLabel>
                  <FormLabel
                    style={{ marginTop: '20px', fontSize: '13px' }}
                    component="legend"
                    color="primary"
                  >
                    OBS: A Triibo cobra uma comissão de 15% sobre o valor total.
                  </FormLabel>
                  <div style={{ display: 'flex', alignItems: 'baseline' }}>
                    <span style={{ marginRight: '4px' }}>R$ </span>
                    <TextField
                      variant="outlined"
                      style={{
                        width: '100px',
                      }}
                      onWheel={(e) => e.target.blur()}
                      className="input-field"
                      autoComplete="off"
                      type="text"
                      disabled={storeType === 'promotion' ? true : false}
                      onChange={handleChange(setCost)}
                      value={priceInReais}
                      id="cost"
                      required={isPublished}
                      onBlur={() => addComma()}
                      onFocus={() => removeComma()}
                    />
                  </div>

                  <div style={{ margin: '10px 0px' }}>
                    <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}>Valor em pontos: </span>
                    <span>{cost ? cost : 0} pts </span>
                  </div>
                </>
              )}
            </div>

            <FormControlLabel
              style={{ marginTop: '10px' }}
              control={
                <Switch
                  checked={isPublished}
                  onChange={(e) => {
                    setIsPublished(e.target.checked);
                    setGoBack(true);
                  }}
                  color="primary"
                />
              }
              label={'Publicar Oferta?'}
            />

            <div
              style={{
                display: unlimitedDisableDate ? 'block' : 'block',
                width: '100%',
              }}
            >
              <TextField
                variant="outlined"
                id="enableDate"
                label="Data de Ativação"
                type="datetime-local"
                value={enableDate === null ? '' : enableDate}
                InputLabelProps={{ shrink: true }}
                onChange={handleChange(setEnableDate)}
                required={isPublished}
              />
            </div>

            <FormControlLabel
              style={{ marginTop: '10px' }}
              control={
                <Switch
                  checked={unlimitedDisableDate}
                  onChange={(e) => {
                    setUnlimitedDisableDate(e.target.checked);
                    setGoBack(true);
                    setDisableDate(convertIsoToDate(new Date(Date.now() + 86400000 * 365 * 60)));
                  }}
                  color="primary"
                />
              }
              label={'Desabilitar data de desativação programada'}
            />
            <div
              style={{
                color: 'red',
                fontSize: '0.7rem',
                fontWeight: 400,
                marginBottom: '1rem',
                padding: 0,
              }}
            >
              *Se a data de desativação for maior que 5 anos esse botão será habilitado
              automaticamente.
            </div>

            <br />
            <div
              style={{
                display: unlimitedDisableDate ? 'none' : 'block',
                width: '100%',
              }}
            >
              <TextField
                variant="outlined"
                id="disableDate"
                label="Data de Desativação"
                type="datetime-local"
                value={disableDate === null ? '' : disableDate}
                InputLabelProps={{ shrink: true }}
                onChange={handleChange(setDisableDate)}
                required={isPublished}
              />
            </div>
          </FormControl>
        </Grid>
        <Button
          style={{
            fontWeight: '550',
            marginTop: '50px',
            color: 'white',
            textTransform: 'capitalize',
          }}
          variant="contained"
          color="secondary"
          onClick={() => goBackFunc()}
          startIcon={<ArrowBack />}
        >
          Voltar
        </Button>
        {/* Botão que abre o dialog */}
        <Button
          style={{
            fontWeight: '550',
            marginTop: '50px',
            marginLeft: '10px',
            color: 'white',
            textTransform: 'capitalize',
          }}
          disabled={!goBack}
          variant="contained"
          color="primary"
          type="button"
          onClick={() => setOpenDialog(true)}
          startIcon={<Save />}
        >
          Salvar
        </Button>
        {openDialog && (
          <Dialog
            open={openDialog}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setOpenDialog(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogContent sx={{ position: 'relative' }}>
              <Box
                sx={{
                  position: 'absolute',
                  right: '20px',
                  top: '20px',
                  cursor: 'pointer',
                }}
                onClick={() => setOpenDialog(false)}
              >
                <Close />
              </Box>
              <DialogContentText
                id="alert-dialog-slide-description"
                sx={{
                  height: 'max-content',
                  paddingLeft: '10px',
                  paddingRight: '15px',
                  marginTop: '40px',
                }}
              >
                {generator
                  ? 'Atenção! Você está gerando uma promoção com estoque ilimitado.'
                  : 'Atenção! Você está gerando uma promoção sem estoque de vouchers, vá até "Gerar Cupons" para gerar estoque.'}
              </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ margin: '0px 15px 10px 10px' }}>
              <Button
                style={{
                  fontWeight: '550',
                  color: 'white',
                  textTransform: 'capitalize',
                }}
                variant="contained"
                color="secondary"
                onClick={() => setOpenDialog(false)}
              >
                Cancelar
              </Button>
              <Button
                style={{
                  fontWeight: '550',
                  color: 'white',
                  textTransform: 'capitalize',
                }}
                variant="contained"
                color="primary"
                onClick={(e) => checkInformation(e)}
                type="buton"
                startIcon={<Save />}
              >
                Salvar
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {/* </form> */}
        {/* ALERTS */}
        <Dialog
          open={openDialogGoBack}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setOpenDialogGoBack(false)}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            {'Deseja voltar a página anterior?'}
          </DialogTitle>

          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              As alterações realizadas não serão salvas.
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenDialogGoBack(false)} color="primary">
              cancelar
            </Button>
            <Button onClick={() => history.goBack()} color="primary">
              voltar
            </Button>
          </DialogActions>
        </Dialog>
        {/* FIM ALERTS */}
      </div>
    );
  }
}

